'use strict';

var _ = require('lodash');
var AnalysisModeController = function AnalysisModeController($scope, $rootScope, dataRetrieverService, dataRetrieverConstantsService, scenarioService, toolbarNextPreviousButtonService, gridRecordsNavigationService, currentStateCriteriaService, $timeout) {
  $scope.screen = dataRetrieverConstantsService.MARKET_SCREEN;
  $scope.selectedRows = [];
  $scope.selectionFilters = [];
  $scope.brushFilters = {};
  $scope.$on('chart:init', function (event, id) {
    $scope.$broadcast(id + ':resetWithDataRetriever');
  });
  $scope.scenarioName = scenarioService.getSelectedScenarioName();
  $scope.triggerChangeFilter = function triggerChangeFilter() {
    if (_.isFunction($scope.changeFilter)) {
      $scope.changeFilter({
        brushData: $scope.brushFilters,
        gridRows: $scope.selectedRows
      });
    }
  };
  $scope.onBrushFilterApplied = function (event, brushFilter, silentSelectionClear) {
    var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.MARKET_SCREEN, $scope.mode);
    var dataRetrieverBookingMatrix = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.MARKET_SCREEN, dataRetrieverConstantsService.BOOKING_MATRIX_MODE);
    if (event.stopPropagation) {
      event.stopPropagation();

      // remove all filters if the selection of date chart was changed
      if (brushFilter.filterType === 'dateRange') {
        var filterSize = _.size($scope.brushFilters);
        if (filterSize > 1 && $scope.brushFilters.dateRange || filterSize > 0 && !$scope.brushFilters.dateRange) {
          //if date range chart brush reset not only itself but some another brush, dateRangeChart
          // should be re-rendered after other charts send its reset filters
          brushFilter.reset = true;
        }
        $scope.brushFilters = {};
      }
      if (!brushFilter.isEmpty()) {
        $scope.brushFilters[brushFilter.filterType] = brushFilter;
      } else {
        delete $scope.brushFilters[brushFilter.filterType];
      }
      dataRetriever.brushFilters($scope.brushFilters);
      dataRetrieverBookingMatrix.brushFilters($scope.brushFilters);
      if (!silentSelectionClear) {
        $scope.$broadcast('brush-filter:filterApplied', brushFilter);
      }
      $scope.triggerChangeFilter();
    }
  };
  $scope.resetCharts = function () {
    $scope.$broadcast('brush-filter:resetCharts');
  };
  $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowsIndexes, selectionFilters, visibleRowProperties) {
    $scope.gridId = gridId;
    $scope.selectedRows = selectedRows;
    $scope.selectionFilters = visibleRowProperties && visibleRowProperties.displayRowFilters;
    $scope.triggerChangeFilter();
    if (gridId === 'market-demand-analysis') {
      var marketGridKey = toolbarNextPreviousButtonService.getRowKeyId(gridId);
      if (visibleRowProperties) {
        gridRecordsNavigationService.setParentGridInformation(visibleRowProperties.displayRows, visibleRowProperties.displayRowIndexes, marketGridKey, visibleRowProperties.displayRowFilters, visibleRowProperties.allRowFilters);
      }
      if (gridRecordsNavigationService.isMarketProductOrService()) {
        $timeout(function () {
          $rootScope.$broadcast('market-analysis-toggle:toggleMode', gridRecordsNavigationService.getMarketGridVisibleMode());
          gridRecordsNavigationService.setMarketGridVisibleMode(undefined);
        }, 0);
      }
    }
  });
  $scope.$on($scope.screen + ':scenariosChanged', function () {
    $scope.cachedSelectionFilters = _.clone($scope.selectionFilters);
  });
  $scope.$on('grid:afterUpdateBoundData', function (event, data, gridId) {
    if ($scope.cachedSelectionFilters) {
      $scope.$broadcast('grid:clearAndSelect:' + gridId, $scope.cachedSelectionFilters);
      delete $scope.cachedSelectionFilters;
    }
    gridRecordsNavigationService.setDemandManagementGridDisplayed(false);
  });
  $scope.onSearchChangeEvent = function () {
    $scope.brushFilters = {};
    setDtdCriteria();
    var scenarios = $scope.scenarioName ? [scenarioService.PUBLISHED, $scope.scenarioName] : [scenarioService.PUBLISHED];
    dataRetrieverService.setScenarios(scenarios, $scope.screen);
  };
  function setDtdCriteria() {
    var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.MARKET_SCREEN, $scope.mode);
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    var dtdCriteria = _.chain(searchCriteria.rules).filter(function (item) {
      return item.shortCriterionName === 'DTD';
    }).map(function (item) {
      return _.pick(item, ['operator', 'leftOperand', 'rightOperand']);
    }).value();
    dataRetriever.updateAdditionalParameters({
      dtdCriteria: dtdCriteria
    });
  }
  $scope.$watch('screenState.dimension', function (newVal, oldVal) {
    if (newVal === oldVal && $scope.completedOnce) {
      return;
    }
    var retriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.MARKET_SCREEN, $scope.mode);
    if (retriever && retriever.updateDimensionValues) {
      if (!$scope.completedOnce) {
        $scope.completedOnce = true;
        retriever.selectedDimension($scope.screenState.dimension);
      } else {
        retriever.updateDimensionValues($scope.screenState.dimension);
      }
    }
  });
  $scope.$on('brush-filter:filterApplied', $scope.onBrushFilterApplied);
  $scope.$on('search-criteria:searchChangeEvent', $scope.onSearchChangeEvent);
  function switchToMarket(direction, gridId) {
    if (!isChildTabGrid(gridId)) {
      return;
    }
    var marketRows = direction === 'Next' ? gridRecordsNavigationService.getParentNextKeyRows() : gridRecordsNavigationService.getParentPreviousKeyRows();
    if (marketRows) {
      gridRecordsNavigationService.setMarketGridVisibleMode(gridId);
      var marketGridKey = toolbarNextPreviousButtonService.getRowKeyId('market-demand-analysis');
      marketRows = _.map(marketRows, function (row) {
        return _.pick(row, marketGridKey);
      });
      $rootScope.$broadcast('grid:clearAndSelect:market-demand-analysis', marketRows);
    }
  }
  function isChildTabGrid(gridId) {
    return gridId === 'market-product-group-analysis' || gridId === 'service-demand-analysis';
  }
  $scope.$on('grid:selectNextKey', function (event, gridId) {
    switchToMarket('Next', gridId);
  });
  $scope.$on('grid:selectPreviousKey', function (event, gridId) {
    switchToMarket('Previous', gridId);
  });
};
AnalysisModeController.$inject = ['$scope', '$rootScope', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ScenarioService', 'ToolbarNextPreviousButtonService', 'GridRecordsNavigationService', 'CurrentStateCriteriaService', '$timeout'];
module.exports = AnalysisModeController;